import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, notification, Form, Space,Tooltip, Modal ,Input} from "antd";
import GenericTable from "../components/GenericTable";
import GenericDrawer from "../components/GenericModal";
import GenericViewModal from "../components/GenericViewModal";
import {
  fetchDiagnosesRequest,
  createDiagnosisRequest,
  updateDiagnosisRequest,
  deleteDiagnosisRequest,
} from "../redux-saga/actions/diagnosisActions";
import { useParams } from "react-router-dom";
import ProjectNavbar from "../components/ProjectNavbar";
import { updateCurrentProjectId } from "../redux-saga/actions/customerActions";
import moment from "moment";
import {fetchEncountersRequest} from "../redux-saga/actions/encounterActions";
import {fetchIcdsRequest} from "../redux-saga/actions/icdActions";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {IconReportMedical} from '@tabler/icons-react';



const DiagnosisPage = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const diagnoses = useSelector((state) => state.diagnosis.diagnoses?.data);
  const loading = useSelector((state) => state.diagnosis.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingDiagnosis, setEditingDiagnosis] = useState(null);
  const [form] = Form.useForm();
  const [viewingDiagnosis, setViewingDiagnosis] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const encounters = useSelector((state) => state.encounter.encounters?.data);
  const icds = useSelector((state) => state.icd.icds?.data);

  const metaData = useSelector((state) => state.diagnosis.diagnoses?.meta || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchEncountersRequest(projectId));
    dispatch(fetchDiagnosesRequest(projectId,{ page: currentPage, limit: 2, search: searchTerm }));
    dispatch(updateCurrentProjectId(projectId));
    dispatch(fetchIcdsRequest(projectId));
  }, [dispatch, projectId,currentPage, searchTerm]);

  const diagnosisModalInputs = [
    { label: "Sequence", name: "sequence", type: "number" },
    { label: "Present on Admission (POA)", name: "POA", type: "text" },
    { label: "Encounter ID", name: "encounterId", type: "select",options: encounters?.map((encounter) => ({
      label: encounter.name,
      value: encounter.id,
    })), },
    { label: "ICD Code ID", name: "icdCodeId", type: "select",options: icds?.map((icd) => ({
      label: icd.name,
      value: icd.id,
    })), },
  ];

  const handleCreateOrEdit = (values) => {
    const payload = {
      sequence: Number(values.sequence),            // Ensure sequence is a number
    POA: String(values.POA),                      // Ensure POA is a string
    encounterId: String(values.encounterId),      // Ensure encounterId is a string
    icdCodeId: String(values.icdCodeId),          // Ensure icdCodeId is a string 
                 
    };
    if (editingDiagnosis) {
      dispatch(updateDiagnosisRequest(editingDiagnosis.id, payload,projectId));
    } else {
      dispatch(createDiagnosisRequest(payload, projectId ));
    }
    notification.success({ message: "Success", description: "Diagnosis saved successfully." });
    setIsModalVisible(false);
    setEditingDiagnosis(null);
    form.resetFields();
  };

  const handleView = (record) => {
    const formattedRecord = {
      ...record,
      createdAt: record.createdAt ? moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss") : null,
      updatedAt: record.updatedAt ? moment(record.updatedAt).format("YYYY-MM-DD HH:mm:ss") : null,
    };
    setViewingDiagnosis(formattedRecord);
    setIsViewModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingDiagnosis(record);
    setIsModalVisible(true);
    form.setFieldsValue(record);
  };

  const handleDelete = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this diagnosis?",
      onOk: () => {
        dispatch(deleteDiagnosisRequest(record.id, projectId));
        notification.success({ message: "Success", description: "Diagnosis deleted successfully." });
      },
    });
  };

  const columnsConfig = [
    { title: "Sequence", dataIndex: "sequence" },
    { title: "POA", dataIndex: "POA" },
    // { title: "Encounter ID", dataIndex: "encounterId" },
    // { title: "ICD Code ID", dataIndex: "icdCodeId" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View">
            <EyeOutlined style={{ fontSize: "20px", color: "#1890ff" }} onClick={() => handleView(record)} />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined style={{ fontSize: "20px", color: "#faad14" }} onClick={() => handleEdit(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleDelete(record)} />
          </Tooltip>
        </Space>
      ),
    },
  ];


  return (
    <div style={{display:"flex",gap:"10px"}}>
       <ProjectNavbar />
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
           <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
              <IconReportMedical style={{ fontSize: "24px", color: "black" }} />
                <h2 style={{ margin: 0 }}>Diagnosis</h2>
            </div>

            <div style={{ display: "flex", justifyContent: "end", marginBottom: 11 }}>
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                Create Diagnosis
              </Button>
            </div>
        </div>
        <Input
          placeholder="Search diagnoses"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
      <GenericTable data={diagnoses} columnsConfig={columnsConfig}  loading={loading} 
      pagination={{
        current: metaData.page || 1,
        pageSize: metaData.limit || 2,
        total: metaData.total || 0,
         onChange: (page, pageSize) => {
          setCurrentPage(page);
          dispatch(fetchDiagnosesRequest({ page, limit: pageSize, search: searchTerm }));
        },
      }} />
      {isModalVisible && (
          <GenericDrawer
            isVisible={isModalVisible}
            handleCancel={() => {
              setIsModalVisible(false);
              setEditingDiagnosis(null);
            }}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconReportMedical style={{ color: "white", marginRight: "8px" }} />
                {editingDiagnosis ? "Edit Encounter" : "Create Encounter"}
              </span>
            }
            inputs={diagnosisModalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingDiagnosis || {}}
          />
        )}
      {isViewModalVisible && (
        <GenericViewModal
          isVisible={isViewModalVisible}
          handleCancel={() => setIsViewModalVisible(false)}
          title="View Diagnosis"
          data={viewingDiagnosis}
          footerButtons={["Close"]}
          onButtonClick={() => setIsViewModalVisible(false)}
        />
      )}
      </div>
    </div>
  );
};

export default DiagnosisPage;
